// extracted by mini-css-extract-plugin
module.exports = {"locationFetcher":"city-picker_locationFetcher__2JFTC"};